import 'ress';
import 'core-js/stable';
import '../scss/style.scss';
import domContentLoaded from 'dom-content-loaded';
// import { throttle } from 'throttle-debounce';
import common from './common';
import topPage from './top';
import navigation from './navigation';
import accordion from './accordion';
import iconEdit from './icon-edit';
import slider from './slider';
import fade from './fade';

common();
topPage(); // トップページ
navigation(); // ナビゲーション
accordion(); // アコーディオン
iconEdit(); // アイコン選択UI
fade(); // 右から表示
// slider();

/**
 * Content Ready
 */
domContentLoaded(() => {
	const menu = $('.js_bl_menu')
	menu.click(function (event) {
		event.preventDefault();
		$('.js_menu_cover, .js_menu, .bl_menuOpnBtn').toggleClass('is_opened is_closed');
		$('body').removeClass('is_locked');
		// リンク先に遷移
		location.href = $(this).attr('href');
	});
});

// ページ内リンク
$(window).on('load scroll', () => {
	const headerHeight = $('header').outerHeight() + 40;
	$('a[href^="#"]').click(function () {
		const href = $(this).attr('href');
		const target = $(href === '#' || href === '' ? 'html' : href);
		const position = target.offset().top - headerHeight;
		$('body,html').stop().animate({ scrollTop: position }, 500);
		return false;
	});
});